import React from 'react';
import { motion } from 'framer-motion';
import { LuStar } from 'react-icons/lu';
import SafeIcon from '../common/SafeIcon';

const testimonials = [
  {
    name: "Ahmad Surrahman",
    role: "Pemilik UMKM Kriya",
    text: "Sejak beralih ke Garuda Ekspress, komplain pelanggan soal pengiriman telat turun drastis. Layanannya profesional dan harganya masuk akal untuk bisnis kecil saya."
  },
  {
    name: "Rika Sartika Haerani",
    role: "Ibu Rumah Tangga",
    text: "Mobil mogok di jalan tol malam-malam, untung ada layanan Garuda Towing. Responsnya sangat cepat, petugasnya ramah, dan mobil saya dievakuasi dengan aman sampai ke bengkel."
  },
  {
    name: "Frederik Simanjuntak",
    role: "Manajer Pengadaan",
    text: "Kargo daratnya luar biasa cepat! Barang proyek yang harusnya sampai dalam 4 hari, bisa sampai dalam 2 hari. Sangat membantu timeline proyek kami."
  }
];

export default function Testimonials() {
  return (
    <section id="testimoni" className="py-24 bg-white relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy mb-4">Apa Kata Mereka?</h2>
          <div className="w-20 h-1.5 bg-orange mx-auto rounded-full mb-6"></div>
          <p className="text-gray-600 text-lg">
            Kepercayaan pelanggan adalah prioritas utama kami. Berikut adalah pengalaman mereka yang telah menggunakan layanan Garuda Ekspress Logistik.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testi, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15 }}
              className="bg-light p-8 rounded-3xl shadow-sm border border-gray-100 flex flex-col items-center text-center relative hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex justify-center text-orange mb-6">
                {[...Array(5)].map((_, i) => (
                  <SafeIcon key={i} icon={LuStar} className="w-5 h-5 fill-current mx-0.5" />
                ))}
              </div>
              <p className="text-gray-700 mb-10 italic relative z-10 leading-relaxed max-w-sm flex-grow">
                "{testi.text}"
              </p>
              <div className="mt-auto">
                <h4 className="font-heading font-bold text-navy text-lg">{testi.name}</h4>
                <p className="text-sm text-gray-500 mt-1">{testi.role}</p>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}